export function createProjectSaveQueue() {
  const entries = new Map();
  const inFlight = new Map();

  async function flush(projectId, save) {
    if (!projectId || typeof save !== "function") return;
    if (inFlight.has(projectId)) return inFlight.get(projectId);

    const operation = (async () => {
      while (entries.has(projectId)) {
        const entry = take(projectId);
        try {
          await save(entry);
        } catch (error) {
          restore(entry);
          throw error;
        }
      }
    })();
    inFlight.set(projectId, operation);
    try {
      return await operation;
    } finally {
      inFlight.delete(projectId);
    }
  }

  function take(projectId) {
    const id = projectId || entries.keys().next().value;
    if (!id || !entries.has(id)) return null;
    const patch = entries.get(id);
    entries.delete(id);
    return { projectId: id, patch };
  }

  function restore(entry) {
    if (!entry) return;
    const newer = entries.get(entry.projectId);
    entries.set(entry.projectId, { ...entry.patch, ...(newer || {}) });
  }

  return {
    enqueue(projectId, patch) {
      if (!projectId || !patch) return;
      entries.set(projectId, { ...(entries.get(projectId) || {}), ...patch });
    },
    take,
    restore,
    flush,
    has(projectId) {
      return projectId ? entries.has(projectId) : entries.size > 0;
    },
    discard(projectId) {
      if (projectId) entries.delete(projectId);
    }
  };
}
